import SettingsPageHeader from "@/components/molecules/SettingsPageHeader";

const System = () => {
  return (
    <div>
      <SettingsPageHeader title="System Controls" />
    </div>
  );
};

export default System;
